module.exports = "<h3>Constancia del pedido {{data.datos.id_pedido}}</h3>\n<div class=\"constancia\">\n  <img src=\"\" class=\"constanciaImg\">\n</div>\n"